function resolveComparator(comparator) {
    switch (comparator) {
        case 'equals':
            return 0;
        case 'notEquals':
            return 1;
        case 'contains':
            return 2;
        case 'containsIgnoreCase':
            return 3;
        case 'notContains':
            return 4;
        case 'startsWith':
            return 5;
        case 'startsWithIgnoreCase':
            return 6;
        case 'isOneOf':
            return 8;
        case 'greaterThan':
            return 10;
        case 'greaterThanEquals':
            return 11;
        case 'lowerThan':
            return 12;
        case 'lowerThanEquals':
            return 13;
        case 'fuzzy':
            return 14;
        case 'isEmpty':
            return 15;
        case 'isNotEmpty':
            return 16;
        default:
            return 0;
    }
}
export default resolveComparator;
//# sourceMappingURL=ComparatorResolver.js.map